import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _080fdd45 = () => interopDefault(import('../../../pages/add-ons-page.vue' /* webpackChunkName: "pages/add-ons-page" */))
const _50f7ade2 = () => interopDefault(import('../../../pages/add-test.vue' /* webpackChunkName: "pages/add-test" */))
const _77e5ef83 = () => interopDefault(import('../../../pages/affiliate-program.vue' /* webpackChunkName: "pages/affiliate-program" */))
const _7a4aedda = () => interopDefault(import('../../../pages/all-goals.vue' /* webpackChunkName: "pages/all-goals" */))
const _b74635a4 = () => interopDefault(import('../../../pages/base-daily.vue' /* webpackChunkName: "pages/base-daily" */))
const _bf3f049a = () => interopDefault(import('../../../pages/base-testing-reviews.vue' /* webpackChunkName: "pages/base-testing-reviews" */))
const _63682d91 = () => interopDefault(import('../../../pages/business.vue' /* webpackChunkName: "pages/business" */))
const _0e1aef5a = () => interopDefault(import('../../../pages/checkout-gift-purchaser.vue' /* webpackChunkName: "pages/checkout-gift-purchaser" */))
const _c8aacc52 = () => interopDefault(import('../../../pages/checkout-improvement-program.vue' /* webpackChunkName: "pages/checkout-improvement-program" */))
const _937f2c60 = () => interopDefault(import('../../../pages/checkout-payment.vue' /* webpackChunkName: "pages/checkout-payment" */))
const _24de8f25 = () => interopDefault(import('../../../pages/checkout-payment-b.vue' /* webpackChunkName: "pages/checkout-payment-b" */))
const _6d10ee55 = () => interopDefault(import('../../../pages/checkout-payment-b2b.vue' /* webpackChunkName: "pages/checkout-payment-b2b" */))
const _24eca6a6 = () => interopDefault(import('../../../pages/checkout-payment-c.vue' /* webpackChunkName: "pages/checkout-payment-c" */))
const _b712da86 = () => interopDefault(import('../../../pages/checkout-payment-gift.vue' /* webpackChunkName: "pages/checkout-payment-gift" */))
const _2f206163 = () => interopDefault(import('../../../pages/checkout-practitioners.vue' /* webpackChunkName: "pages/checkout-practitioners" */))
const _03d0932f = () => interopDefault(import('../../../pages/collection.vue' /* webpackChunkName: "pages/collection" */))
const _78cc9bd9 = () => interopDefault(import('../../../pages/complete-testing-plan.vue' /* webpackChunkName: "pages/complete-testing-plan" */))
const _12b2f5d1 = () => interopDefault(import('../../../pages/digital-subs-upsell.vue' /* webpackChunkName: "pages/digital-subs-upsell" */))
const _dfb1a43c = () => interopDefault(import('../../../pages/food-allergy.vue' /* webpackChunkName: "pages/food-allergy" */))
const _f24766fe = () => interopDefault(import('../../../pages/food-sensitivity.vue' /* webpackChunkName: "pages/food-sensitivity" */))
const _cb54247c = () => interopDefault(import('../../../pages/gifts.vue' /* webpackChunkName: "pages/gifts" */))
const _d7d8c9a8 = () => interopDefault(import('../../../pages/gifts-base.vue' /* webpackChunkName: "pages/gifts-base" */))
const _6e50d3d0 = () => interopDefault(import('../../../pages/giveaway.vue' /* webpackChunkName: "pages/giveaway" */))
const _208dcdae = () => interopDefault(import('../../../pages/goal-gift.vue' /* webpackChunkName: "pages/goal-gift" */))
const _54d75c0e = () => interopDefault(import('../../../pages/how-it-works.vue' /* webpackChunkName: "pages/how-it-works" */))
const _590f8d8a = () => interopDefault(import('../../../pages/marketplace.vue' /* webpackChunkName: "pages/marketplace" */))
const _6b0b1d79 = () => interopDefault(import('../../../pages/new-password.vue' /* webpackChunkName: "pages/new-password" */))
const _2e0ae687 = () => interopDefault(import('../../../pages/not-found.vue' /* webpackChunkName: "pages/not-found" */))
const _6283a044 = () => interopDefault(import('../../../pages/nutritional-plan.vue' /* webpackChunkName: "pages/nutritional-plan" */))
const _c44a6692 = () => interopDefault(import('../../../pages/nutritional-plan-confirm.vue' /* webpackChunkName: "pages/nutritional-plan-confirm" */))
const _616eb03c = () => interopDefault(import('../../../pages/practitioners-referral.vue' /* webpackChunkName: "pages/practitioners-referral" */))
const _1e6e3ea8 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _e8b87bb4 = () => interopDefault(import('../../../pages/quiz.vue' /* webpackChunkName: "pages/quiz" */))
const _2ecd29fb = () => interopDefault(import('../../../pages/quiz-b.vue' /* webpackChunkName: "pages/quiz-b" */))
const _4e223570 = () => interopDefault(import('../../../pages/quiz-base.vue' /* webpackChunkName: "pages/quiz-base" */))
const _55dc0c9d = () => interopDefault(import('../../../pages/quiz-base-b.vue' /* webpackChunkName: "pages/quiz-base-b" */))
const _55ea241e = () => interopDefault(import('../../../pages/quiz-base-c.vue' /* webpackChunkName: "pages/quiz-base-c" */))
const _760a2309 = () => interopDefault(import('../../../pages/quiz-base-diet.vue' /* webpackChunkName: "pages/quiz-base-diet" */))
const _191ede1e = () => interopDefault(import('../../../pages/quiz-base-diet-b.vue' /* webpackChunkName: "pages/quiz-base-diet-b" */))
const _192cf59f = () => interopDefault(import('../../../pages/quiz-base-diet-c.vue' /* webpackChunkName: "pages/quiz-base-diet-c" */))
const _4731cc80 = () => interopDefault(import('../../../pages/quiz-base-partners.vue' /* webpackChunkName: "pages/quiz-base-partners" */))
const _5c190315 = () => interopDefault(import('../../../pages/quiz-base-partners-b.vue' /* webpackChunkName: "pages/quiz-base-partners-b" */))
const _2edb417c = () => interopDefault(import('../../../pages/quiz-c.vue' /* webpackChunkName: "pages/quiz-c" */))
const _722b0027 = () => interopDefault(import('../../../pages/quiz-gift.vue' /* webpackChunkName: "pages/quiz-gift" */))
const _06d9c4ea = () => interopDefault(import('../../../pages/quiz-gifting.vue' /* webpackChunkName: "pages/quiz-gifting" */))
const _66cfbc70 = () => interopDefault(import('../../../pages/quiz-landing.vue' /* webpackChunkName: "pages/quiz-landing" */))
const _2a34b6cf = () => interopDefault(import('../../../pages/quiz-results.vue' /* webpackChunkName: "pages/quiz-results" */))
const _6cf39864 = () => interopDefault(import('../../../pages/quiz-results-b.vue' /* webpackChunkName: "pages/quiz-results-b" */))
const _6d01afe5 = () => interopDefault(import('../../../pages/quiz-results-c.vue' /* webpackChunkName: "pages/quiz-results-c" */))
const _6d0fc766 = () => interopDefault(import('../../../pages/quiz-results-d.vue' /* webpackChunkName: "pages/quiz-results-d" */))
const _62e8d82c = () => interopDefault(import('../../../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _5689bada = () => interopDefault(import('../../../pages/reviews.vue' /* webpackChunkName: "pages/reviews" */))
const _d5e1d6ba = () => interopDefault(import('../../../pages/science.vue' /* webpackChunkName: "pages/science" */))
const _6c79bee4 = () => interopDefault(import('../../../pages/successful-payment.vue' /* webpackChunkName: "pages/successful-payment" */))
const _c2896e2e = () => interopDefault(import('../../../pages/successful-payment-datadog.vue' /* webpackChunkName: "pages/successful-payment-datadog" */))
const _1db88ff4 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _3517b25a = () => interopDefault(import('../../../pages/thanks.vue' /* webpackChunkName: "pages/thanks" */))
const _1befec0b = () => interopDefault(import('../../../pages/tiktok.vue' /* webpackChunkName: "pages/tiktok" */))
const _50c8bdfc = () => interopDefault(import('../../../pages/upgrade-fast-track.vue' /* webpackChunkName: "pages/upgrade-fast-track" */))
const _3252bdd8 = () => interopDefault(import('../../../pages/whitepaper.vue' /* webpackChunkName: "pages/whitepaper" */))
const _66a5eb3d = () => interopDefault(import('../../../pages/providers/home.vue' /* webpackChunkName: "pages/providers/home" */))
const _6c527e19 = () => interopDefault(import('../../../pages/providers/terms.vue' /* webpackChunkName: "pages/providers/terms" */))
const _63378ebc = () => interopDefault(import('../../../pages/providers/test-catalog.vue' /* webpackChunkName: "pages/providers/test-catalog" */))
const _6a12768c = () => interopDefault(import('../../../pages/providers/videos-and-faqs.vue' /* webpackChunkName: "pages/providers/videos-and-faqs" */))
const _31cadea5 = () => interopDefault(import('../../../pages/providers/videos/_video.vue' /* webpackChunkName: "pages/providers/videos/_video" */))
const _60534221 = () => interopDefault(import('../../../pages/affiliate/_affiliate.vue' /* webpackChunkName: "pages/affiliate/_affiliate" */))
const _25ad6cb6 = () => interopDefault(import('../../../pages/app/_feature.vue' /* webpackChunkName: "pages/app/_feature" */))
const _766cd901 = () => interopDefault(import('../../../pages/b2b/_b2b.vue' /* webpackChunkName: "pages/b2b/_b2b" */))
const _3d0c1a87 = () => interopDefault(import('../../../pages/goal/_goal.vue' /* webpackChunkName: "pages/goal/_goal" */))
const _2654eec2 = () => interopDefault(import('../../../pages/test/_biomarker.vue' /* webpackChunkName: "pages/test/_biomarker" */))
const _4725f9d1 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/add-ons-page",
    component: _080fdd45,
    alias: "/add-ons-page.html",
    name: "add-ons-page___en"
  }, {
    path: "/add-test",
    component: _50f7ade2,
    alias: "/add-test.html",
    name: "add-test___en"
  }, {
    path: "/affiliate-program",
    component: _77e5ef83,
    alias: "/affiliate-program.html",
    name: "affiliate-program___en"
  }, {
    path: "/all-goals",
    component: _7a4aedda,
    alias: "/all-goals.html",
    name: "all-goals___en"
  }, {
    path: "/base-daily",
    component: _b74635a4,
    alias: "/base-daily.html",
    name: "base-daily___en"
  }, {
    path: "/base-testing-reviews",
    component: _bf3f049a,
    alias: "/base-testing-reviews.html",
    name: "base-testing-reviews___en"
  }, {
    path: "/business",
    component: _63682d91,
    alias: "/business.html",
    name: "business___en"
  }, {
    path: "/checkout-gift-purchaser",
    component: _0e1aef5a,
    alias: "/checkout-gift-purchaser.html",
    name: "checkout-gift-purchaser___en"
  }, {
    path: "/checkout-improvement-program",
    component: _c8aacc52,
    alias: "/checkout-improvement-program.html",
    name: "checkout-improvement-program___en"
  }, {
    path: "/checkout-payment",
    component: _937f2c60,
    alias: "/checkout-payment.html",
    name: "checkout-payment___en"
  }, {
    path: "/checkout-payment-b",
    component: _24de8f25,
    alias: "/checkout-payment-b.html",
    name: "checkout-payment-b___en"
  }, {
    path: "/checkout-payment-b2b",
    component: _6d10ee55,
    alias: "/checkout-payment-b2b.html",
    name: "checkout-payment-b2b___en"
  }, {
    path: "/checkout-payment-c",
    component: _24eca6a6,
    alias: "/checkout-payment-c.html",
    name: "checkout-payment-c___en"
  }, {
    path: "/checkout-payment-gift",
    component: _b712da86,
    alias: "/checkout-payment-gift.html",
    name: "checkout-payment-gift___en"
  }, {
    path: "/checkout-practitioners",
    component: _2f206163,
    alias: "/checkout-practitioners.html",
    name: "checkout-practitioners___en"
  }, {
    path: "/collection",
    component: _03d0932f,
    alias: "/collection.html",
    name: "collection___en"
  }, {
    path: "/complete-testing-plan",
    component: _78cc9bd9,
    alias: "/complete-testing-plan.html",
    name: "complete-testing-plan___en"
  }, {
    path: "/digital-subs-upsell",
    component: _12b2f5d1,
    alias: "/digital-subs-upsell.html",
    name: "digital-subs-upsell___en"
  }, {
    path: "/food-allergy",
    component: _dfb1a43c,
    alias: "/food-allergy.html",
    name: "food-allergy___en"
  }, {
    path: "/food-sensitivity",
    component: _f24766fe,
    alias: "/food-sensitivity.html",
    name: "food-sensitivity___en"
  }, {
    path: "/gifts",
    component: _cb54247c,
    alias: "/gifts.html",
    name: "gifts___en"
  }, {
    path: "/gifts-base",
    component: _d7d8c9a8,
    alias: "/gifts-base.html",
    name: "gifts-base___en"
  }, {
    path: "/giveaway",
    component: _6e50d3d0,
    alias: "/giveaway.html",
    name: "giveaway___en"
  }, {
    path: "/goal-gift",
    component: _208dcdae,
    alias: "/goal-gift.html",
    name: "goal-gift___en"
  }, {
    path: "/how-it-works",
    component: _54d75c0e,
    alias: "/how-it-works.html",
    name: "how-it-works___en"
  }, {
    path: "/marketplace",
    component: _590f8d8a,
    alias: "/marketplace.html",
    name: "marketplace___en"
  }, {
    path: "/new-password",
    component: _6b0b1d79,
    alias: "/new-password.html",
    name: "new-password___en"
  }, {
    path: "/not-found",
    component: _2e0ae687,
    alias: "/not-found.html",
    name: "not-found___en"
  }, {
    path: "/nutritional-plan",
    component: _6283a044,
    alias: "/nutritional-plan.html",
    name: "nutritional-plan___en"
  }, {
    path: "/nutritional-plan-confirm",
    component: _c44a6692,
    alias: "/nutritional-plan-confirm.html",
    name: "nutritional-plan-confirm___en"
  }, {
    path: "/practitioners-referral",
    component: _616eb03c,
    alias: "/practitioners-referral.html",
    name: "practitioners-referral___en"
  }, {
    path: "/privacy-policy",
    component: _1e6e3ea8,
    alias: "/privacy-policy.html",
    name: "privacy-policy___en"
  }, {
    path: "/quiz",
    component: _e8b87bb4,
    alias: "/quiz.html",
    name: "quiz___en"
  }, {
    path: "/quiz-b",
    component: _2ecd29fb,
    alias: "/quiz-b.html",
    name: "quiz-b___en"
  }, {
    path: "/quiz-base",
    component: _4e223570,
    alias: "/quiz-base.html",
    name: "quiz-base___en"
  }, {
    path: "/quiz-base-b",
    component: _55dc0c9d,
    alias: "/quiz-base-b.html",
    name: "quiz-base-b___en"
  }, {
    path: "/quiz-base-c",
    component: _55ea241e,
    alias: "/quiz-base-c.html",
    name: "quiz-base-c___en"
  }, {
    path: "/quiz-base-diet",
    component: _760a2309,
    alias: "/quiz-base-diet.html",
    name: "quiz-base-diet___en"
  }, {
    path: "/quiz-base-diet-b",
    component: _191ede1e,
    alias: "/quiz-base-diet-b.html",
    name: "quiz-base-diet-b___en"
  }, {
    path: "/quiz-base-diet-c",
    component: _192cf59f,
    alias: "/quiz-base-diet-c.html",
    name: "quiz-base-diet-c___en"
  }, {
    path: "/quiz-base-partners",
    component: _4731cc80,
    alias: "/quiz-base-partners.html",
    name: "quiz-base-partners___en"
  }, {
    path: "/quiz-base-partners-b",
    component: _5c190315,
    alias: "/quiz-base-partners-b.html",
    name: "quiz-base-partners-b___en"
  }, {
    path: "/quiz-c",
    component: _2edb417c,
    alias: "/quiz-c.html",
    name: "quiz-c___en"
  }, {
    path: "/quiz-gift",
    component: _722b0027,
    alias: "/quiz-gift.html",
    name: "quiz-gift___en"
  }, {
    path: "/quiz-gifting",
    component: _06d9c4ea,
    alias: "/quiz-gifting.html",
    name: "quiz-gifting___en"
  }, {
    path: "/quiz-landing",
    component: _66cfbc70,
    alias: "/quiz-landing.html",
    name: "quiz-landing___en"
  }, {
    path: "/quiz-results",
    component: _2a34b6cf,
    alias: "/quiz-results.html",
    name: "quiz-results___en"
  }, {
    path: "/quiz-results-b",
    component: _6cf39864,
    alias: "/quiz-results-b.html",
    name: "quiz-results-b___en"
  }, {
    path: "/quiz-results-c",
    component: _6d01afe5,
    alias: "/quiz-results-c.html",
    name: "quiz-results-c___en"
  }, {
    path: "/quiz-results-d",
    component: _6d0fc766,
    alias: "/quiz-results-d.html",
    name: "quiz-results-d___en"
  }, {
    path: "/reset-password",
    component: _62e8d82c,
    alias: "/reset-password.html",
    name: "reset-password___en"
  }, {
    path: "/reviews",
    component: _5689bada,
    alias: "/reviews.html",
    name: "reviews___en"
  }, {
    path: "/science",
    component: _d5e1d6ba,
    alias: "/science.html",
    name: "science___en"
  }, {
    path: "/successful-payment",
    component: _6c79bee4,
    alias: "/successful-payment.html",
    name: "successful-payment___en"
  }, {
    path: "/successful-payment-datadog",
    component: _c2896e2e,
    alias: "/successful-payment-datadog.html",
    name: "successful-payment-datadog___en"
  }, {
    path: "/terms",
    component: _1db88ff4,
    alias: "/terms.html",
    name: "terms___en"
  }, {
    path: "/thanks",
    component: _3517b25a,
    alias: "/thanks.html",
    name: "thanks___en"
  }, {
    path: "/tiktok",
    component: _1befec0b,
    alias: "/tiktok.html",
    name: "tiktok___en"
  }, {
    path: "/upgrade-fast-track",
    component: _50c8bdfc,
    alias: "/upgrade-fast-track.html",
    name: "upgrade-fast-track___en"
  }, {
    path: "/whitepaper",
    component: _3252bdd8,
    alias: "/whitepaper.html",
    name: "whitepaper___en"
  }, {
    path: "/providers/home",
    component: _66a5eb3d,
    alias: "/providers/home.html",
    name: "providers-home___en"
  }, {
    path: "/providers/terms",
    component: _6c527e19,
    alias: "/providers/terms.html",
    name: "providers-terms___en"
  }, {
    path: "/providers/test-catalog",
    component: _63378ebc,
    alias: "/providers/test-catalog.html",
    name: "providers-test-catalog___en"
  }, {
    path: "/providers/videos-and-faqs",
    component: _6a12768c,
    alias: "/providers/videos-and-faqs.html",
    name: "providers-videos-and-faqs___en"
  }, {
    path: "/providers/videos/:video?",
    component: _31cadea5,
    alias: "/providers/videos/:video?.html",
    name: "providers-videos-video___en"
  }, {
    path: "/affiliate/:affiliate?",
    component: _60534221,
    alias: "/affiliate/:affiliate?.html",
    name: "affiliate-affiliate___en"
  }, {
    path: "/app/:feature?",
    component: _25ad6cb6,
    alias: "/app/:feature?.html",
    name: "app-feature___en"
  }, {
    path: "/b2b/:b2b?",
    component: _766cd901,
    alias: "/b2b/:b2b?.html",
    name: "b2b-b2b___en"
  }, {
    path: "/goal/:goal?",
    component: _3d0c1a87,
    alias: "/goal/:goal?.html",
    name: "goal-goal___en"
  }, {
    path: "/test/:biomarker?",
    component: _2654eec2,
    alias: "/test/:biomarker?.html",
    name: "test-biomarker___en"
  }, {
    path: "/",
    component: _4725f9d1,
    alias: "/index.html",
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
